import {
    AnimationLoadingBaseController,
    IAnimationControllerConfiguration,
    ILoadingBaseController,
    Inject, SoundManager, SoundType,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../AnimationContents';
import { GameModel } from '../Models/GameModel';
import { remapValue } from '../Common/Utils';
import { Sounds } from '../Constants/Sounds';
import { Graphics } from 'pixi.js';

export interface ILoaderGameControllerOptions {
    test: string;
}

export class LoaderGameController extends AnimationLoadingBaseController implements ILoadingBaseController {
    public $model: GameModel;

    private _width: number = 0;
    private _height: number = 0;
    private _scale: number = 1;

    private _graphics: Graphics;

    public constructor(
        @Inject private _options: ILoaderGameControllerOptions
    ) {
        super('LoaderGameController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.LOADER_SCREEN_JSON,
            libraryName: 'loader_screen',
            sounds: [
                {
                    id: Sounds.MUSIC_MENU,
                    type: SoundType.Music,
                },
            ],
        };
    }

    protected onInitialize(): void {
        if (!this._graphics) {
            this._graphics = new Graphics();
            this._graphics.interactive = false;
        }

        this.renderer.stage.addChildAt(this._graphics, 0);

        if (!this.soundManager.isSoundPlaying(Sounds.MUSIC_MENU)) {
            this.soundManager.play(Sounds.MUSIC_MENU, true, 1);
        }
    }

    protected  onDestroy() {
        this.renderer.stage.removeChild(this._graphics);
    }

    protected onUpdate(frameRate: number): void {
        this._resize();
    }

    public onLoadingProgress(progress: number) {
        this.gotoAndStopByQuery('progress', Math.floor(remapValue(progress, 0, 1, 0, 99)));
    }

    public onHide(): void {
    }

    public onShow(): void {
    }

    protected onResize(width: number, height: number, scale: number) {
        this._width = width;
        this._height = height;
        this._scale = scale;

        this._resize();
    }

    private _resize(width: number = this._width, height: number = this._height, scale: number = this._scale): void {
        if (this._graphics) {
            const w = width / scale;
            const h = height / scale;

            this._graphics.clear();
            this._graphics.beginFill(0x1C0440, 1);
            this._graphics.drawRect(0,0, w, h);
            this._graphics.endFill();
        }

        this.scaleX = this.scaleY = Math.min(
            this._width / this._scale / this.$model.gameWidth,
            this._height / this._scale / this.$model.gameHeight,
        );
    }
}
